import { create } from 'zustand';

interface DisableButtonState {
    disableButton: boolean;
    setDisableButton: (open: boolean) => void;
}

// Create the Zustand store with types
const useDisableStore = create<DisableButtonState>((set) => ({
    disableButton: false,
    setDisableButton: (open: boolean) => set({ disableButton: open }),
}));

export default useDisableStore;
